import { usePickerContext } from "./usePickerContext";
import { useTicketsBuilder } from "./useTicketsBuilder";

export function useValidator() {
    // console.log('useValidator')

    const { state } = usePickerContext();
    const { dates, tickets } = useTicketsBuilder({
        onlyCurrentDate: state.typeWidget === 'FREE',
        sortByDate: state.typeWidget === 'PASS'
    });

    let error = null;
    switch (state.typeWidget) {
        case 'FREE': {
            if (tickets.length < 1) error = state.translations.PLC_MSG_ERR_SELECTION_PLACE;
            break;
        }
        case 'PASS': {
            const quantityDate = (hour) => {
                let data = {};
                if (hour.tickets) {
                    hour.tickets.forEach(ticket => {
                        if(ticket.hour.widget.startHour !== hour.at){
                            return
                        } 
                        let prices = hour.widget.pricing.filter(price => price.categoryId === ticket.categoryId);

                        dates.forEach(date => {
                            date.hours[0].widget.categories.forEach(categorie =>{
                                if(categorie.id === ticket.categoryId){
                                    prices = date.hours[0].widget.pricing
                                }
                            })
                        })
                        
                        const currPrice = !ticket.formulaCode ? prices[0] : prices.filter(price => price.formulaCode === ticket.formulaCode)[0];
                        // Dans le cas d'un Pass détaillé & Prix detaillé, on ne fait plus le test avec la clé de prestation mais uniquement le code formule
                        //const key = `${currPrice.serviceCode}|${currPrice.formulaCode}`;
                        const key = `${currPrice.formulaCode}`;
                        data[key] = typeof data[key] !== 'undefined' ? data[key] + 1 : 1;
                    });
                }
                return data;
            };

            const validateDates = (dates) => {
                let visited = null
                //Check si tous les concerts on des places de sélectionnés
                let isValid = dates.every(date => date.hours.every(hour => hour.tickets.length > 0));

                if (isValid) {
                    dates.forEach(date => {
                        date.hours.forEach(hour => {
                            const quantity = quantityDate(hour);
                            const ordered = {};
                            Object.keys(quantity).sort().forEach(function(key) {
                                ordered[key] = quantity[key];
                            });
                            if (visited && JSON.stringify(ordered) !== visited) {
                                isValid = false;
                            }
                            visited = JSON.stringify(ordered);
                        })
                    });
                }
                return isValid;
            };

            //On lance le check nb tickets / formules
            if (!validateDates(dates)) {
                error = state.translations.PLC_MSG_ERR_VALIDITE_PLACES;
            }
        }
    }

    return { error }
}